export const TIMER_THEME_OPTIONS = [
  {
    id: 'light',
    label: 'Blanco',
  },
  {
    id: 'dark',
    label: 'Oscuro',
  },
  {
    id: 'custom',
    label: 'Custom 1',
  },
  {
    id: 'custom_2',
    label: 'Custom 2',
  },
];

export const ALLOWED_TIMER_THEMES = TIMER_THEME_OPTIONS.map((option) => option.id);

export function isAllowedTimerTheme(theme) {
  return ALLOWED_TIMER_THEMES.includes(String(theme || '').toLowerCase());
}

export function normalizeTimerTheme(theme) {
  const normalized = String(theme || '').toLowerCase();
  return isAllowedTimerTheme(normalized) ? normalized : 'dark';
}

export function isCustomTimerTheme(theme) {
  return ['custom', 'custom_2'].includes(normalizeTimerTheme(theme));
}